import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { load, schemas } from 'api'
import { applyHOCs, selectSlug } from 'helpers'
import { page, pageLoadSelectors, PageHead } from 'page'

import WebinarPage from './WebinarPage'
import { refreshWebinar } from './actions'

class WebinarRoute extends React.Component {
  componentWillReceiveProps (nextProps) {
    if (!nextProps.webinar ||
      !nextProps.webinar.start_at ||
      this.refreshTimeouts) return

    const { start_at: start, join_opens_at: joinOpensAt } = nextProps.webinar
    const buffer = moment.duration(2, 'minutes').asMilliseconds()
    const now = moment()

    // Refetch shortly before start (to pick up any late data), when the
    // Zoom join window opens (so the disabled Join button can enable
    // itself without a manual reload), and at start itself.
    const targets = [
      moment(start).subtract(buffer, 'milliseconds'),
      joinOpensAt && moment(joinOpensAt),
      moment(start)
    ].filter(Boolean)

    this.refreshTimeouts = targets
      .map(target => target.diff(now))
      .filter(timeRemaining => timeRemaining > 0)
      .map(timeRemaining => setTimeout(this.props.onWebinarRefresh, timeRemaining))
  }

  componentWillUnmount () {
    if (this.refreshTimeouts) {
      this.refreshTimeouts.forEach(clearTimeout)
    }
  }

  render () {
    const { webinar } = this.props
    return (
      <div>
        <PageHead title={webinar.title} />
        <WebinarPage webinar={webinar} />
      </div>
    )
  }
}

export default applyHOCs([
  page({
    ...pageLoadSelectors('webinar'),
    pageType: 'webinar',
    noPageHead: true
  }),
  load({
    webinar: {
      urlSelector: (state, props) => {
        return `/v2/webinars/slug/${props.slug}`
      },
      schema: schemas.webinar
    }
  }),
  connect(null, (dispatch, ownProps) => ({
    onWebinarRefresh: () => {
      dispatch(refreshWebinar(ownProps.slug))
    }
  })),
  selectSlug()
])(WebinarRoute)
